module.exports = __webpack_public_path__ + "static/media/gc-hotel.04b02a4f.png";